import type React from "react";

import { useTranslation } from "react-i18next";
import type { IconType } from "react-icons";

import { RefreshIcon } from "../app/components/icons";

import "./error-screen.scss";

interface Props {
  title: string;
  description: string;
  Icon: IconType;
}

const ErrorScreen: React.FC<Props> = ({ title, description, Icon }) => {
  const { t } = useTranslation();

  return (
    <div aria-hidden className={`error-screen is-shown`}>
      <div className={`error-screen__content is-shown`}>
        {<Icon />}
        <div className="error-screen__content__text">
          <p>
            <strong>{title}</strong>
          </p>
          <p>{description}</p>
        </div>
        <button
          type="button"
          onClick={() => {
            location.reload();
          }}
        >
          <RefreshIcon />
          {t("generic.refresh")}
        </button>
      </div>
    </div>
  );
};

export default ErrorScreen;
